import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgVisalColored({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.477 6.025c-.674-.254-1.724-.525-3.046-.525-3.354 0-5.718 1.69-5.736 4.106-.017 1.786 1.69 2.784 2.978 3.388 1.322.613 1.768.998 1.76 1.541-.01.832-1.06 1.217-2.032 1.217-1.357 0-2.084-.192-3.195-.656l-.438-.202-.473 2.784c.796.35 2.258.648 3.782.666 3.572 0 5.884-1.672 5.91-4.256.009-1.418-.893-2.494-2.854-3.387-1.191-.579-1.918-.964-1.909-1.542 0-.516.613-1.068 1.944-1.068a6.189 6.189 0 012.539.482l.306.14.464-2.688zM17.77 18.178l2.128-12.46h3.397l-2.128 12.46H17.77zM39.562 5.736h2.627l2.749 12.45h-3.152s-.306-1.427-.411-1.865l-2.405-.005h-.007l-1.94-.004-.718 1.874h-3.563L37.785 6.77c.36-.814.963-1.033 1.777-1.033zm-1.567 8.029c.28-.718 1.348-3.485 1.348-3.485l.067-.177c.095-.246.268-.694.38-1.014l.227 1.077s.649 2.977.789 3.599h-2.81zm-26.397.455l3.327-8.493h3.59L13.174 18.16h-3.59L6.546 7.27c2.153 1.077 4.08 3.239 4.701 5.226l.35 1.725z"
        fill="#0057A0"
      />
      <path
        d="M8.516 5.719H3.044L3 5.98c4.255 1.033 7.074 3.52 8.247 6.514l-1.19-5.726c-.201-.788-.806-1.015-1.541-1.05z"
        fill="#FAA61A"
      />
    </svg>
  )
}

export default SvgVisalColored
